import(/* webpackMode: "eager" */ "E:\\Final Projects Repo\\LocoBuzzWebsite\\locobuzz-website\\app\\platform\\integrations\\page.js");
